import React, { useState } from "react";
import { StyleSheet, View, ImageBackground } from "react-native";
import { Text } from "react-native-paper";
import routes from "../../routing/routes";
import { blackColor, dividerColor } from "../../common/colors";
import PageContainer from "../../common/PageContainer";
import t from "../../translations";
import { List, Divider } from "react-native-paper";
import { languageData } from "./languageData";
import IconIonicons from "react-native-vector-icons/Ionicons";
import { connect } from "react-redux";
import { actionCreators } from './action';
import T from '../T';

const ApplicationLanguage = (props) => {
  const onClick = (item) => {
    console.log('item', item);
    props.changeLanguage(item)
  }
  return (
    <PageContainer
      {...props}
      isBackIcon={true}
      isSettingsIconSelected={true}
      backRoute={routes.Settings}
      noBackground={true}
    >
      <View style={styles.infoContainer}>
        <Text style={styles.info}><T>list_title_SelectedLanguage</T>: {props.language}</Text>
        <Text style={styles.info}><T>list_title_ApplicationLanguage</T></Text>
      </View>
      {languageData.map((item, key) => {
        return (
          <React.Fragment key={`application-language-${key}`}>
            <List.Section style={styles.navigateContainer}>
              <List.Item
                onPress={()=>onClick(item)}
                left={() => (
                  <View>
                    <View style={styles.contentContainer}>
                      <ImageBackground
                        source={item.flagImage}
                        style={styles.image}
                      />
                      <Text style={styles.title}>{item.title}</Text>
                      {props.language === item.code  && (
                        <View style={styles.iconContainer}>
                          <IconIonicons
                            name="checkmark"
                            size={21}
                            color={blackColor}
                          />
                        </View>
                      )}
                    </View>
                  </View>
                )}
              />
              <Divider style={styles.divider} />
            </List.Section>
          </React.Fragment>
        );
      })}
    </PageContainer>
  );
};

export default connect(
  (store) => ({
        language: store.language
  }), actionCreators)(ApplicationLanguage);

const styles = StyleSheet.create({
  infoContainer: {
    paddingTop: 23,
    paddingLeft: 20,
    alignItems: "flex-start",
    alignContent: "center",
    justifyContent: "center",
  },
  info: {
    fontSize: 16,
    lineHeight: 26,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: blackColor,
    textTransform: "uppercase",
  },
  navigateContainer: {
    top: 0,
    color: blackColor,
  },
  divider: {
    width: "94%",
    backgroundColor: dividerColor,
  },
  title: {
    fontWeight: "400",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1.25,
    marginLeft: 8,
  },
  contentContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: 24,
    height: 24,
  },
  iconContainer: {
    justifyContent: "flex-end",
    alignItems: "center",
    paddingLeft: 20,
  },
});
